import { IOffsiteCampaignType, ISegmentFilterType, IVisitorMessageType } from '../../entities/offsiteCampaign';
import { TFunction } from 'react-i18next';

const defaultSegmentFilterTypes = ['custom', 'testing'] as ISegmentFilterType[];

export interface SegmentConfig {
  availableChannelTypes: IVisitorMessageType[];
  availableSegmentFilterTypes: ISegmentFilterType[];
  defaultTemplateId?: string;
  title: string;
}
export const getSegmentConfig = (
  campaignType: IOffsiteCampaignType,
  activeChannels: IVisitorMessageType[],
  t: TFunction<'campaigns'>,
): SegmentConfig => {
  if (campaignType === 'cartAbandonment' || campaignType === 'browseAbandonment') {
    return {
      availableChannelTypes: activeChannels,
      availableSegmentFilterTypes: defaultSegmentFilterTypes,
      defaultTemplateId: null,
      title: t(`offsiteEditor.segments.configs.title.${campaignType}`),
    };
  }
};
